<template>
  <div
    :class="[
      $style.base,
      {
        [$style.disabled]: isDisabled,
        [$style.inverted]: inverted,
      }
    ]"
  >
    <div
      :class="[$style.left, { [$style.padding1]: leftPadding === 1, [$style.padding15]: leftPadding === 1.5 }]"
      :style="
        isDisabled
          ? {}
          : {
              width: width + '%'
            }
      "
    >
      <slot name="left" />
    </div>
    <div
      :class="[$style.right, { [$style.padding1]: rightPadding === 1, [$style.padding15]: rightPadding === 1.5 }]"
      :style="
        isDisabled
          ? {}
          : {
              width: 100 - width + '%'
            }
      "
    >
      <slot name="right" />
    </div>
  </div>
</template>

<script
  setup
  lang="ts"
>
import { usePageLayoutStore } from '@/stores/page-layout';

const props = withDefaults(
  defineProps<{
    disabled?: boolean;
    inverted?: boolean;
    padding?: 0 | 1 | 1.5 | Array<0 | 1 | 1.5>;
    width?: number;
  }>(),
  {
    disabled: false,
    inverted: false,
    padding: 1,
    width: 50,
  },
);

const isDisabled = computed(() => {
  const { screenSize } = usePageLayoutStore();
  return props.disabled || screenSize === 's';
});

const leftPadding = computed(() =>
  Array.isArray(props.padding) ? props.padding[0] : props.padding,
);
const rightPadding = computed(() =>
  Array.isArray(props.padding) ? props.padding[1] : props.padding,
);
</script>

<style
  lang="scss"
  module
>
.base {
  &:not(.disabled) {
    display: flex;
    align-items: stretch;
    height: 100%;
  }
}

.left,
.right {
  .base:not(.disabled) & {
    width: 50%;
    overflow-y: auto;
  }

  &.padding1 {
    padding: $spacing;
  }

  &.padding15 {
    padding: $spacing * 1.5;
  }
}

.left {
  .base:not(.disabled) & {
    background-color: var(--color-bg);
  }

  .base.inverted & {
    background-color: var(--color-bg-secondary);
  }

  .base:not(.inverted) & {
    background-color: var(--color-bg);
  }
}

.right {
  .base:not(.disabled) & {
    border-left: 1px solid var(--color-border);
  }

  .base.inverted & {
    background-color: var(--color-bg);
  }

  .base:not(.inverted) & {
    background-color: var(--color-bg-secondary);
  }
}
</style>
